import { OnboardingTaskKey } from '@/types/api/group/onboarding-task';

export function onboardingLabel(key: OnboardingTaskKey): string {
  // prettier-ignore
  switch (key) {
    case OnboardingTaskKey.InviteMembers:       return "Bjud in deltagare";
    case OnboardingTaskKey.CreatePayoutAccount: return "Registrera utbetalningskonto";
    case OnboardingTaskKey.CreateSale:          return "Starta försäljning";
    default:                                    return "Okänt"
  }
}

/** Why the task matters, shown under its label */
export function onboardingDescription(key: OnboardingTaskKey): string {
  // prettier-ignore
  switch (key) {
    case OnboardingTaskKey.InviteMembers:       return "Dela länken med deltagarna – de går med på under en minut";
    case OnboardingTaskKey.CreatePayoutAccount: return "Så att pengarna hamnar hos er";
    case OnboardingTaskKey.CreateSale:          return "Välj sista beställningsdag och ert mål, sen kan ni börja sälja";
    default:                                    return ""
  }
}

export function onboardingDuration(key: OnboardingTaskKey): string {
  // prettier-ignore
  switch (key) {
    case OnboardingTaskKey.InviteMembers:       return "ca 1 min";
    case OnboardingTaskKey.CreatePayoutAccount: return "ca 2 min med BankID";
    case OnboardingTaskKey.CreateSale:          return "ca 1 min";
    default:                                    return ""
  }
}

/** What a disabled task waits on */
export function onboardingDisabledReason(key: OnboardingTaskKey): string {
  // prettier-ignore
  switch (key) {
    case OnboardingTaskKey.CreateSale:          return "Kräver utbetalningskonto";
    default:                                    return "Kräver tidigare steg"
  }
}
